import { getPerson } from '../../../slices/questionnaireSlice/utils/helpers'

export default {
  /**
   * Set all person.cancers list: [{}]
   * @type {(state: WritableDraft<{}>,
   *  action: { payload: [{ id: string, cancerId: string, label: string }]}
   * )}
   */
  setPersonCancers: (state, action) => {
    const person = getPerson(state, action)
    const { value } = action.payload

    if (!value.length) {
      delete person.cancers

      return
    }

    const _value = value.map((cancer) => {
      cancer.qualifiers.forEach((qualifier) => {
        if (qualifier.numericAgeAtDiagnosis === '') {
          delete qualifier.numericAgeAtDiagnosis
        }
      })

      return cancer
    })

    person.cancers = _value
  },
  /**
   * Add a cancer to person.cancers list: [{}]
   * @type {(state: WritableDraft<{}>,
   *  action: { payload: { id: string, value: {
   *    cancerId: string, label: string, qualifiers, treatments
   *  }}}
   * )}
   */
  addPersonCancer: (state, action) => {
    const person = getPerson(state, action)
    const { cancer } = action.payload
    const { id, label } = cancer

    if (!person.cancers) {
      person.cancers = []
    }
    if (!id || !label) {
      throw new Error('addPersonCancer failed: id and label are required')
    }

    const index = person.cancers.findIndex((cancer) => cancer.id === id)

    if (index !== -1) {
      person.cancers[index] = { ...person.cancers[index], ...cancer }
    } else {
      person.cancers = [...person.cancers, { ...cancer, isPresent: 'Y' }]
    }
  },
  /**
   * Remove a cancer from person.cancers list: [{}]
   * @type {(state: WritableDraft<{}>,
   *  action: { payload: { id: string, cancerId: string }}
   * )}
   */
  removePersonCancer: (state, action) => {
    const person = getPerson(state, action)
    const { cancerId } = action.payload

    if (!person.cancers) {
      return
    }

    person.cancers = person.cancers.filter((cancer) => cancer.id !== cancerId)
  },
}
